import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";
import { PopUnder } from "./components/PopUnder";
import { LocationPopup } from "./components/LocationPopup";
import Index from "./pages/Index";
import ArubaResolver from "./pages/ArubaResolver";
import NotFound from "./pages/NotFound";

// Code-split heavier / less-frequently visited routes
const Auth = lazy(() => import("./pages/Auth"));
const Admin = lazy(() => import("./pages/Admin"));
const AdminArticles = lazy(() => import("./pages/AdminArticles"));
const ArticleEditor = lazy(() => import("./pages/ArticleEditor"));
const ArticlePage = lazy(() => import("./pages/ArticlePage"));
const ArticlesIndex = lazy(() => import("./pages/ArticlesIndex"));

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <ScrollToTop />
        <PopUnder />
        <LocationPopup />
        <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/aruba/things-to-do" element={<ArticlesIndex />} />
            <Route path="/aruba/things-to-do/:slug" element={<ArticlePage />} />
            <Route path="/aruba/:slug" element={<ArubaResolver />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/admin/articles" element={<AdminArticles />} />
            <Route path="/admin/articles/edit/:slug" element={<ArticleEditor />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
